export const routes = [
  {
    path: '/accounts/membership',
    name: 'account_membership',
    // The component is retained deliberately: when nextgen_admin is off, this Classic page
    // still renders. Only the redirect is flag-gated.
    meta: { newAppPath: '/accounts/membership' },
    component: () => import('../pages/AccountMembershipPage.vue'),
  },
  {
    path: '/company/',
    name: 'useradmin',
    // Every Classic useradmin page breadcrumbs back here, so with nextgen_admin on those
    // breadcrumbs land on the NextGen overview. Its cards still link out to the Classic
    // sub-pages that have not been migrated yet.
    meta: { newAppPath: '/company' },
    component: () => import('../pages/CompanyAdminPage.vue'),
  },
  {
    path: '/accounts/profile',
    name: 'account_profile',
    props: true,
    // Retained for the same reason as the membership route above.
    meta: { newAppPath: '/accounts/profile' },
    component: () => import('../pages/AccountProfilePage.vue'),
  },
  {
    path: '/company/users/:id',
    name: 'member_detail',
    props: true,
    // NextGen renamed the segment from users to members; the id is substituted by
    // replaceUrlParameter. Retained for the same reason as the routes above.
    meta: { newAppPath: '/company/members/:id' },
    component: () => import('../pages/MemberDetailPage.vue'),
  },
  {
    path: '/company/users',
    name: 'users',
    props: true,
    meta: { newAppPath: '/company/members' },
    component: () => import('../pages/MembersPage.vue'),
  },
  {
    path: '/company/partnership',
    name: 'partnership',
    props: true,
    meta: { newAppPath: '/company/partnerships' },
    component: () => import('../pages/PartnershipsPage.vue'),
  },
  {
    path: '/company/partnership/partners',
    name: 'partners',
    props: true,
    component: () => import('../pages/AvailablePartnersPage.vue'),
  },
  {
    path: '/company/partnership/:partnershipId',
    name: 'partner_info',
    props: true,
    component: () => import('../pages/PartnershipDetailPage.vue'),
  },
  {
    path: '/company/connected_systems',
    name: 'connected_systems',
    props: true,
    component: () => import('../pages/ConnectedSystemsPage.vue'),
  },
  {
    path: '/company/connected_systems/add',
    name: 'connected_systems_add',
    props: true,
    component: () => import('../pages/ConnectedSystemPage.vue'),
  },
  {
    path: '/company/connected_systems/:id',
    name: 'connected_systems_edit',
    props: true,
    component: () => import('../pages/ConnectedSystemPage.vue'),
  },
  {
    path: '/company/notifications',
    name: 'notifications',
    component: () => import('../pages/NotificationsPage.vue'),
  },
  {
    path: '/company/notifications/preferences',
    name: 'notification-preferences',
    // The component is retained deliberately: when nextgen_admin is off, this Classic page
    // still renders. Unlike the investor-status precedent, this is not a redirect-only stub.
    meta: { newAppPath: '/notifications/preferences' },
    component: () => import('../pages/NotificationPreferencesPage.vue'),
  },
  {
    path: '/company/exception-management/approval-groups',
    name: 'approval-groups',
    component: () => import('../pages/ApprovalGroupsPage.vue'),
  },
  {
    path: '/company/exception-management/approval-groups/:id',
    name: 'approval-group',
    component: () => import('../pages/ApprovalGroupPage.vue'),
  },
  {
    path: '/company/exception-management/requestor-groups',
    name: 'requestor-groups',
    component: () => import('../pages/RequestorGroupsPage.vue'),
  },
  {
    path: '/company/exception-management/requestor-groups/:id',
    name: 'requestor-group',
    component: () => import('../pages/RequestorGroupPage.vue'),
  },
  {
    path: '/company/noexchangerole/',
    name: 'no-exchangerole',
    meta: { msg: 'noExchangeRole' },
    component: () => import('../pages/NoPermissionPage.vue'),
  },
  {
    path: '/company/nopartnership/',
    name: 'no-partnership',
    meta: {
      msg: 'noPartnership',
      linkTo: { name: 'partnership' },
      linkText: 'Partnership Page',
    },
    component: () => import('../pages/NoPermissionPage.vue'),
  },
  {
    path: '/company/nopermission/',
    name: 'no-permission',
    meta: { msg: 'noPermission' },
    component: () => import('../pages/NoPermissionPage.vue'),
  },
  {
    path: '/company/pricing-engine/',
    name: 'pricing-engine-settings',
    component: () => import('../pages/PricingEngineSettingsPage.vue'),
  },
];
